import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { mapProduct, type Product, type ProductRow } from './types';

const PRODUCT_COLUMNS =
  'id, slug, name, description, price, compare_at_price, sizes, sold_out, stock, is_active, sort_order, category, created_at, product_images(id, storage_path, thumb_path, alt, position)';

export async function fetchProducts(): Promise<Product[]> {
  const { data, error } = await supabase
    .from('products')
    .select(PRODUCT_COLUMNS)
    .eq('is_active', true)
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: false });

  if (error) throw error;
  return ((data ?? []) as unknown as ProductRow[]).map(mapProduct);
}

export const productKeys = {
  all: ['products'] as const,
  list: () => [...productKeys.all, 'list'] as const,
};

export function useProducts() {
  return useQuery({
    queryKey: productKeys.list(),
    queryFn: fetchProducts,
  });
}
